import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { environment } from '../../../../environments/environment.development';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { AuthService } from '../../../auth/services/auth/auth.service';
import { SessionService } from '../../../auth/services/session/session.service';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import type { DocumentInStorage, Document as DocumentType } from '../../models/documents.model';

interface ResponseDocuments {
  data: DocumentType[];
}

export interface FiltersCharts {
  from_time: string;
  to_time: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private _http = inject(HttpClient);
  private _authService = inject(AuthService);
  private _sessionService = inject(SessionService);
  private _localStorage = inject(LocalStorageService);

  private url = `${environment.apiUrl}/administrative`;

  constructor() { }

  exportPdfBackend(filter: FiltersCharts, UrlChart: string) {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    let params = new HttpParams();

    if (filter.from_time && filter.to_time) {
      params = params.append('from_time', filter.from_time);
      params = params.append('to_time', filter.to_time);
    }

    const documentsUrl = `${this.url}${UrlChart}`;

    return this._http.get<{ data: string }>(documentsUrl, { headers: { Authorization: `Bearer ${token}` }, params });
  }

  getDocuments(eventId: string): Observable<ResponseDocuments> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const documentsUrl = `${this.url}/events/${eventId}/documents_pdf/`;

    return this._http.get<ResponseDocuments>(documentsUrl, { headers: { Authorization: `Bearer ${token}` } });
  }

  getDocumentInStorage(url: string): Observable<DocumentInStorage> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const documentUrl = `${this.url}/${url}`;

    return this._http.get<DocumentInStorage>(documentUrl, { headers: { Authorization: `Bearer ${token}` } });
  }

  getServiceOrderPdf(eventId: string): Observable<DocumentInStorage> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const documentUrl = `${this.url}/events/${eventId}/pdf_order/`;

    return this._http.get<DocumentInStorage>(documentUrl, { headers: { Authorization: `Bearer ${token}` } }).pipe(
      catchError((error: any) => {
        if (error.status === 500) {
          console.error('Server error occurred:', error);
          return throwError(() => new Error('Internal Server Error. Please try again later.'));
        }

        return throwError(() => error);
      })
    );
  }

  getServiceCertificatePdf(eventId: string): Observable<DocumentInStorage> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const documentUrl = `${this.url}/events/${eventId}/pdf_certificate/`;

    return this._http.get<DocumentInStorage>(documentUrl, { headers: { Authorization: `Bearer ${token}` } }).pipe(
      catchError((error: any) => {
        if (error.status === 500) {
          console.error('Server error occurred:', error);
          return throwError(() => new Error('Internal Server Error. Please try again later.'));
        }

        return throwError(() => error);
      })
    );
  }

  getCalendarDocument(): Observable<DocumentInStorage> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const customerId = this._sessionService!.Customer.id;

    const documentUrl = `${this.url}/customers/${customerId}/pdf_calendar`;

    return this._http.get<DocumentInStorage>(documentUrl, { headers: { Authorization: `Bearer ${token}` } });
  }
}
